import { useState } from 'react';
import { Link } from 'react-router-dom';

const vipPlans = [
  {
    id: 'monthly',
    name: '月度会员',
    price: 19,
    period: '月',
    tag: '灵活选择',
    features: ['全站无广告观看', '1080P高清画质', '优先观看最新剧集', '多端同步观看进度'],
    highlight: false,
  },
  {
    id: 'quarterly',
    name: '季度会员',
    price: 49,
    period: '季度',
    tag: '性价比之选',
    features: ['全站无广告观看', '1080P高清画质', '优先观看最新剧集', '多端同步观看进度', '专属客服通道'],
    highlight: true,
  },
  {
    id: 'annual',
    name: '年度会员',
    price: 168,
    period: '年',
    tag: '最划算',
    features: ['全站无广告观看', '4K超清画质', '优先观看最新剧集', '多端同步观看进度', '专属客服通道', '赠送3个月时长'],
    highlight: false,
  },
];

export default function VipPage() {
  const [selectedPlan, setSelectedPlan] = useState('quarterly');
  const [showPayment, setShowPayment] = useState(false);

  const plan = vipPlans.find((p) => p.id === selectedPlan) || vipPlans[1];

  const handleOpenPayment = () => {
    setShowPayment(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleBackToPlans = () => {
    setShowPayment(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-background-50">
      <header className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200">
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-[72px] max-w-[1400px] mx-auto">
            <Link to="/" className="flex items-center gap-2 text-foreground-950 no-underline cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading text-lg">努</span>
              <span className="text-xl font-heading font-bold whitespace-nowrap">努努影院</span>
            </Link>
            <div className="flex items-center gap-3">
              <Link to="/category" className="text-sm text-foreground-600 hover:text-primary-500 cursor-pointer">分类浏览</Link>
              <Link to="/search" className="text-sm text-foreground-600 hover:text-primary-500 cursor-pointer">搜索</Link>
            </div>
          </div>
        </div>
      </header>

      <div className="pt-[72px]">
        {!showPayment ? (
          <div className="w-full px-4 md:px-6 max-w-[1100px] mx-auto py-12 md:py-16">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
                <i className="ri-vip-crown-line"></i>
                VIP 会员特权
              </div>
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">升级 VIP，尊享极致追剧体验</h1>
              <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">去除广告干扰，解锁高清画质，优先观看最新剧集，让追剧回归纯粹的快乐</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10">
              {vipPlans.map((p) => (
                <button
                  key={p.id}
                  type="button"
                  onClick={() => setSelectedPlan(p.id)}
                  className={`relative rounded-2xl border-2 p-6 text-left transition-all duration-300 ${
                    selectedPlan === p.id
                      ? 'border-primary-500 bg-primary-50/50'
                      : 'border-background-200 bg-background-100 hover:border-background-300'
                  }`}
                >
                  {p.highlight ? (
                    <span className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-accent-500 text-background-50 text-xs font-bold rounded-full whitespace-nowrap">
                      {p.tag}
                    </span>
                  ) : (
                    <span className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 bg-secondary-500 text-background-50 text-xs font-bold rounded-full whitespace-nowrap">
                      {p.tag}
                    </span>
                  )}
                  <h3 className="text-base font-bold text-foreground-900 mb-2 mt-2">{p.name}</h3>
                  <div className="flex items-baseline gap-1 mb-4">
                    <span className="text-3xl font-heading font-bold text-primary-500">¥{p.price}</span>
                    <span className="text-xs text-foreground-400">/{p.period}</span>
                  </div>
                  <ul className="flex flex-col gap-2">
                    {p.features.map((feat) => (
                      <li key={feat} className="flex items-start gap-2 text-xs text-foreground-600">
                        <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                        {feat}
                      </li>
                    ))}
                  </ul>
                </button>
              ))}
            </div>

            <div className="text-center">
              <button
                type="button"
                onClick={handleOpenPayment}
                className="inline-flex items-center gap-2 px-10 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-base hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-secure-payment-line"></i>
                立即开通 ¥{plan.price}/{plan.period}
              </button>
            </div>
          </div>
        ) : (
          <div className="w-full px-4 md:px-6 max-w-[800px] mx-auto py-8">
            <button
              type="button"
              onClick={handleBackToPlans}
              className="inline-flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 mb-6"
            >
              <i className="ri-arrow-left-line"></i>
              返回选择套餐
            </button>

            <div className="bg-background-100 border border-background-200 rounded-2xl p-6 md:p-8 mb-8">
              <h2 className="text-xl font-heading font-bold text-foreground-950 mb-4">支付订单</h2>
              <div className="flex items-center justify-between py-3 border-b border-background-200">
                <span className="text-sm text-foreground-600">套餐名称</span>
                <span className="text-sm font-bold text-foreground-900">{plan.name}</span>
              </div>
              <div className="flex items-center justify-between py-3">
                <span className="text-sm text-foreground-600">应付金额</span>
                <span className="text-xl font-heading font-bold text-primary-500">¥{plan.price}</span>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="bg-background-100 border border-background-200 rounded-2xl p-5 text-center">
                <div className="flex items-center gap-2 justify-center mb-4">
                  <span className="w-8 h-8 flex items-center justify-center bg-green-100 text-green-600 rounded-lg text-lg">
                    <i className="ri-wechat-fill"></i>
                  </span>
                  <span className="text-sm font-bold text-foreground-900">微信支付</span>
                </div>
                <div className="w-40 h-40 mx-auto bg-background-50 border border-background-200 rounded-lg flex items-center justify-center mb-3">
                  <img
                    src="https://readdy.ai/api/search-image?query=WeChat%20Pay%20QR%20code%20placeholder%20on%20white%20background%2C%20green%20border%20frame%2C%20small%20WeChat%20logo%20at%20bottom%2C%20clean%20minimalist%20design%2C%20payment%20scan%20code%20style&width=320&height=320&seq=wechat-qr-001&orientation=squarish"
                    alt="微信支付二维码"
                    className="w-full h-full object-contain p-2"
                    onError={(e) => { const t = e.currentTarget; t.style.display = 'none'; }}
                  />
                </div>
                <p className="text-xs text-foreground-400">打开微信扫一扫完成支付</p>
              </div>

              <div className="bg-background-100 border border-background-200 rounded-2xl p-5 text-center">
                <div className="flex items-center gap-2 justify-center mb-4">
                  <span className="w-8 h-8 flex items-center justify-center bg-blue-100 text-blue-600 rounded-lg text-lg">
                    <i className="ri-alipay-fill"></i>
                  </span>
                  <span className="text-sm font-bold text-foreground-900">支付宝</span>
                </div>
                <div className="w-40 h-40 mx-auto bg-background-50 border border-background-200 rounded-lg flex items-center justify-center mb-3">
                  <img
                    src="https://readdy.ai/api/search-image?query=Alipay%20QR%20code%20placeholder%20on%20white%20background%2C%20blue%20border%20frame%2C%20small%20Alipay%20logo%20at%20bottom%2C%20clean%20minimalist%20design%2C%20payment%20scan%20code%20style&width=320&height=320&seq=alipay-qr-001&orientation=squarish"
                    alt="支付宝二维码"
                    className="w-full h-full object-contain p-2"
                    onError={(e) => { const t = e.currentTarget; t.style.display = 'none'; }}
                  />
                </div>
                <p className="text-xs text-foreground-400">打开支付宝扫一扫完成支付</p>
              </div>

              <div className="bg-background-100 border border-background-200 rounded-2xl p-5">
                <div className="flex items-center gap-2 justify-center mb-4">
                  <span className="w-8 h-8 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg text-lg">
                    <i className="ri-bank-card-line"></i>
                  </span>
                  <span className="text-sm font-bold text-foreground-900">Toss Pay</span>
                </div>
                <div className="space-y-3">
                  <div>
                    <label className="block text-xs text-foreground-500 mb-1">持卡人姓名</label>
                    <input
                      type="text"
                      placeholder="请输入姓名"
                      className="w-full px-3 py-2 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-300"
                    />
                  </div>
                  <div>
                    <label className="block text-xs text-foreground-500 mb-1">支付金额 (KRW)</label>
                    <input
                      type="text"
                      value={`₩${(plan.price * 190).toLocaleString()}`}
                      readOnly
                      className="w-full px-3 py-2 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-900"
                    />
                  </div>
                  <button type="button" className="w-full py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap">
                    确认支付
                  </button>
                </div>
                <p className="text-[10px] text-foreground-400 mt-3 text-center">此表单为演示用途，不处理真实支付</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}